import React from 'react';
import SafeIcon from '../../common/SafeIcon';

// ✅ 靜態 class 對應表：Tailwind 可靜態分析，不會被 purge
const COLOR_CLASSES = {
  blue: {
    wrapper: 'bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200',
    title:   'text-blue-600',
    value:   'text-blue-900',
    sub:     'text-blue-700',
    icon:    'text-blue-500',
  },
  green: {
    wrapper: 'bg-gradient-to-br from-green-50 to-green-100 border-green-200',
    title:   'text-green-600',
    value:   'text-green-900',
    sub:     'text-green-700',
    icon:    'text-green-500',
  },
  purple: {
    wrapper: 'bg-gradient-to-br from-purple-50 to-purple-100 border-purple-200',
    title:   'text-purple-600',
    value:   'text-purple-900',
    sub:     'text-purple-700',
    icon:    'text-purple-500',
  },
  orange: {
    wrapper: 'bg-gradient-to-br from-orange-50 to-orange-100 border-orange-200',
    title:   'text-orange-600',
    value:   'text-orange-900',
    sub:     'text-orange-700',
    icon:    'text-orange-500',
  },
};

const StatsCard = React.memo(({ icon, title, value, subtitle, color = 'blue' }) => {
  const cls = COLOR_CLASSES[color] || COLOR_CLASSES.blue;
  return (
    <div className={`${cls.wrapper} rounded-xl p-6 border shadow-lg hover:shadow-xl transition-shadow duration-200`}>
      <div className="flex items-center justify-between">
        <div>
          <p className={`${cls.title} text-sm font-medium mb-1`}>{title}</p>
          <p className={`${cls.value} text-3xl font-bold`}>{value}</p>
          {subtitle && <p className={`${cls.sub} text-xs mt-1`}>{subtitle}</p>}
        </div>
        <SafeIcon icon={icon} className={`h-10 w-10 ${cls.icon} opacity-80`} />
      </div>
    </div>
  );
});

export default StatsCard;